import i18n from '@/settings/i18n';
import { seoT } from './types';
import en from './en.json';
import fr from './fr.json';
import de from './de.json';
import es from './es.json';
import it from './it.json';
import nl from './nl.json';
import sv from './sv.json';

const locales: Record<string, Partial<seoT>> = { en, fr, de, es, it, nl, sv };

const seo = new Proxy({} as seoT, {
  get(_target, handle: string) {
    const localized = locales[i18n.getLocale()]?.[handle];

    return localized ?? (en as Partial<seoT>)[handle];
  },
});

export default seo;
